<app-base-modal
  [open]="open"
  (openChange)="openChange.emit($event)"
  title="Create Research-Group"
  [size]="'lg'"
>
  <form id="groupForm" class="space-y-4" (ngSubmit)="submit()" [formGroup]="groupForm">
    <div>
      <label class="block text-sm font-bold text-gray-700 mb-1">Name</label>
      <input
        type="text"
        formControlName="name"
        placeholder="Enter group name"
        class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-secondary"
      />
      @if (submitted && groupForm.controls.name.errors?.required) {
        <small class="text-sm text-red-600">Name is required.</small>
      }
    </div>

    <div>
      <label class="block text-sm font-bold text-gray-700 mb-1">Description</label>
      <textarea
        formControlName="description"
        rows="3"
        class="w-full px-3 py-2 h-32 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-secondary"
      ></textarea>
    </div>

    @if (error) {
      <app-base-alert
        type="error"
        title="Error creating group"
        [message]="error.detail"
        (closed)="error = ''"
      ></app-base-alert>
    }

    <div data-modal-footer class="flex justify-end gap-2">
      <button
        type="button"
        class="px-4 py-2 bg-gray-200 hover:bg-gray-300 rounded-md transition-colors"
        (click)="close()"
      >
        Cancel
      </button>
      <button
        type="submit"
        class="px-4 py-2 bg-secondary hover:bg-hover text-white rounded-md transition-colors"
      >
        Create
      </button>
    </div>
  </form>
</app-base-modal>
